import { Injectable } from '@angular/core';
import { API } from './api.service';

@Injectable()
export class LoggingService {


    constructor(private api: API) {

    }

    public logEntity(type: string, params: any) {
        if (!params.played_from) {
            params.played_from = '';
        }
        let url = '';
        switch (type) {
            case 'time':
                url = 'songs/time-logging';
                break;
             case 'song':
                url = 'songs/play-logging';
                break;
            case 'playlist':
                url = 'playlists/play-logging';
                break;
            case 'artist':
                url = 'artists/play-logging';
                break;
            case 'album':
                url = 'albums/play-logging';
                break;
            case 'radio':
                url = 'playlists/radio-logging';
                break;
        }
        return this.api.post(url, params);
    }

}



// WEBPACK FOOTER //
// ./src/app/api/services/logging.service.ts